import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../lib/utils";
const Label = React.forwardRef(({ className, ...props }, ref) => {
    return (_jsx("label", { className: cn("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-light-text dark:text-dark-text", className), ref: ref, ...props }));
});
Label.displayName = "Label";
export { Label };
